import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { isRequired, validateEndDate } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import RegisteredBusSelect from '../../../common/forms/select/RegisteredBusSelect';
import CitySelect from '../../../common/forms/select/CitySelect';
import Select from '../../../common/forms/select/Select';
import { BUS_MAINTENANCE_STATUS_TYPE } from '../../../../config/constants';
import { enumToSelectOptions } from '../../../../utils/enum';
import TextInput from '../../../common/forms/input/TextInput';
import { DATE_TIME_FORMAT } from '../../../../config/locale';

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.estimatedArrivalDate);

export const BusMaintenanceStayForm = ({
  handleSubmit,
  loading,
  edit,
  currentStatus,
  currentCompletionDate,
}) => {

  const maintenanceData = !!(
    (currentStatus && currentStatus !== '') ||
    (currentCompletionDate && currentCompletionDate !== '')
  );

  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Bus" required>
          <Field
            name="registeredBusId"
            component={RegisteredBusSelect}
            placeholder="Bus"
            validate={[isRequired]}
            isDisabled={edit}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Ciudad de Origen" required>
          <Field
            name="originCityId"
            component={CitySelect}
            validate={[isRequired]}
            isDisabled={edit}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Fecha de Llegada" required={maintenanceData}>
          <Field
            name="estimatedArrivalDate"
            component={TextInput}
            type="datetime-local"
            placeholder={DATE_TIME_FORMAT}
            validate={maintenanceData ? [isRequired] : []}
          />
        </FormItem>
      </FormGroup>

      {edit && (
        <>
          <FormGroup row>
            <FormItem label="Estado de Mantenimiento" required={maintenanceData}>
              <Field
                name="maintenanceStayStatus"
                component={Select}
                options={enumToSelectOptions(BUS_MAINTENANCE_STATUS_TYPE)}
                isClearable={false}
                validate={maintenanceData ? [isRequired] : []}
              />
            </FormItem>
          </FormGroup>

          <FormGroup row>
            <FormItem label="Fecha de Entrega" required={maintenanceData}>
              <Field
                name="estimatedCompletionDate"
                component={TextInput}
                type="datetime-local"
                placeholder={DATE_TIME_FORMAT}
                validate={maintenanceData ? [isRequired, validateDate] : [validateDate]}
              />
            </FormItem>
          </FormGroup>

          <FormGroup row>
            <FormItem label="Observación">
              <Field
                name="observation"
                component={TextInput}
                type="textarea"
                placeholder="Nota"
              />
            </FormItem>
          </FormGroup>
        </>
      )}

      <FormFooter />
    </Form>
  );
};

BusMaintenanceStayForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  edit: PropTypes.bool,
  currentStatus: PropTypes.string,
  currentCompletionDate: PropTypes.string,
};

BusMaintenanceStayForm.defaultProps = {
  loading: false,
  edit: false,
  currentStatus: null,
  currentCompletionDate: null,
};

const selector = formValueSelector('BusMaintenanceStayForm');

const mapStateToProps = (state) => ({
  loading: !state.MechanicalMaintenanceUnit.BusMaintenanceStay.getIn([
    'current',
    'activity',
  ]).isEmpty(),
  currentStatus: selector(state, 'maintenanceStayStatus'),
  currentCompletionDate: selector(state, 'estimatedCompletionDate'),
});

const formComponent = reduxForm({
  form: 'BusMaintenanceStayForm',
})(BusMaintenanceStayForm);

export default connect(mapStateToProps)(formComponent);